import _defineProperty from "@babel/runtime/helpers/defineProperty";
import getAllProperties from '../../utils/object/getAllProperties.js';
import RefsManager from './RefsManager.js';
export default class EventsManager {
  constructor(rootElement, base) {
    _defineProperty(this, "__rootElement", void 0);

    _defineProperty(this, "__base", void 0);

    _defineProperty(this, "__methodsCache", new Map());

    _defineProperty(this, "__rootElementHandler", {
      handleEvent: event => {
        var normalizedEventName = EventsManager.normalizeName(event.type);
        var method = "on".concat(normalizedEventName);

        this.__base[method](event);
      }
    });

    _defineProperty(this, "__refsHandler", {
      handleEvent: event => {
        var ref = event.currentTarget;
        var refName = RefsManager.normalizeRefName(ref.dataset.ref);
        var normalizedRefName = EventsManager.normalizeName(refName);
        var normalizedEventName = EventsManager.normalizeName(event.type);
        var method = "on".concat(normalizedRefName).concat(normalizedEventName);
        var index = 0;

        if (Array.isArray(this.__base.$refs[refName])) {
          index = this.__base.$refs[refName].indexOf(ref);
        }

        this.__base[method](event, index);
      }
    });

    _defineProperty(this, "__childrenHandler", {
      handleEvent: event => {
        var child = event.currentTarget.__base__;
        var childName;
        var index = 0;
        var childrenManager = this.__base.$children;
        childrenManager.registeredNames.find(name => {
          if (childrenManager[name].includes(child)) {
            childName = name;
            index = childrenManager[name].indexOf(child);
            return true;
          }

          return false;
        });
        var normalizedRefName = EventsManager.normalizeName(childName);
        var normalizedEventName = EventsManager.normalizeName(event.type);
        var method = "on".concat(normalizedRefName).concat(normalizedEventName);
        var args = Array.isArray(event.detail) ? event.detail : [];

        this.__base[method](...args, index, event);
      }
    });

    Object.defineProperties(this, {
      __rootElement: {
        enumerable: false,
        writable: false,
        value: rootElement
      },
      __base: {
        enumerable: false,
        writable: false,
        value: base
      },
      __methodsCache: {
        enumerable: false,
        writable: false,
        value: this.__methodsCache
      },
      __rootElementHandler: {
        enumerable: false,
        writable: false,
        value: this.__rootElementHandler
      },
      __refsHandler: {
        enumerable: false,
        writable: false,
        value: this.__refsHandler
      },
      __childrenHandler: {
        enumerable: false,
        writable: false,
        value: this.__childrenHandler
      }
    });
  }

  __manageRef(name, elements) {
    var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'add';
    var action = "".concat(mode, "EventListener");

    var methods = this.__getEventMethodsByName(name);

    methods.forEach(method => {
      var event = this.__getEventNameByMethod(method, name);

      elements.forEach(element => element[action](event, this.__refsHandler));
    });
  }

  bindRef(name, elements) {
    this.__manageRef(name, elements);
  }

  unbindRef(name, elements) {
    this.__manageRef(name, elements, 'remove');
  }

  __manageChild(name, instance) {
    var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'add';
    var action = mode === 'add' ? '$on' : '$off';

    var methods = this.__getEventMethodsByName(name);

    methods.forEach(method => {
      var event = this.__getEventNameByMethod(method, name);

      instance[action](event, this.__childrenHandler);
    });
  }

  bindChild(name, instance) {
    this.__manageChild(name, instance);
  }

  unbindChild(name, instance) {
    this.__manageChild(name, instance, 'remove');
  }

  __manageRootElement() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'add';
    var modeMethod = "".concat(mode, "EventListener");

    var methods = this.__getEventMethodsByName();

    methods.forEach(method => {
      var event = this.__getEventNameByMethod(method);

      this.__rootElement[modeMethod](event, this.__rootElementHandler);
    });
  }

  bindRootElement() {
    this.__manageRootElement();
  }

  unbindRootElement() {
    this.__manageRootElement('remove');
  }

  __getEventNameByMethod(method) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var normalizedName = EventsManager.normalizeName(name);
    var regex = new RegExp("^on".concat(normalizedName, "([A-Z].*)$"));
    var [, event] = method.match(regex);
    return EventsManager.normalizeEventName(event);
  }

  __getEventMethodsByName() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var normalizedName = EventsManager.normalizeName(name);
    var regex = new RegExp("^on".concat(normalizedName, "[A-Z].*$"));
    var key = regex.toString();

    var methods = this.__methodsCache.get(key);

    if (!methods) {
      methods = Array.from(getAllProperties(this.__base, [], method => regex.test(method)).reduce((set, _ref) => {
        var [method] = _ref;
        return set.add(method);
      }, new Set()));

      this.__methodsCache.set(key, methods);
    }

    return methods;
  }

  static normalizeName(name) {
    return name.replace(/[A-Z]([A-Z].*)/g, c => c.toLowerCase()).replace(/[^a-zA-Z\d\s:]/g, ' ').replace(/(^\w|\s+\w)/g, c => c.trim().toUpperCase()).trim();
  }

  static normalizeEventName(name) {
    return name.replace(/[A-Z]/g, c => "-".concat(c.toLowerCase())).replace(/^-/, '');
  }

}